import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Alert } from "react-bootstrap";
import axios from "axios";
import { isExpired } from "../tokenUtils";
import { clearAllCache } from "../../../utils/apiCache";

const Login = () => {
  const routes = all_routes;
  const navigation = useNavigate();

  const [username, setUsername] = useState('');
//   useEffect(() => {
//   const token = localStorage.getItem("token");

//   if (token) {
//     navigation("/index");
//   }
// }, []);

  const [password, setPassword] = useState('');
  const [school_id, setSchoolId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [error1, setError1] = useState('');
  const [error2, setError2] = useState('');
  const [error3, setError3] = useState('');
  const authToken = localStorage.getItem("token");
  const [Automationdata, setAutomationdata] = useState();
  const [showAdmissionLogin, setShowAdmissionLogin] = useState(false);
  const [showAdmissionLoginData, setShowAdmissionLoginData] = useState(false);

  // Forgot password flow: "login" -> "forgot" (send OTP) -> "reset" (OTP + new password)
  const [view, setView] = useState("login");
  const [fpUsername, setFpUsername] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fpLoading, setFpLoading] = useState(false);
  const [fpError, setFpError] = useState("");
  const [fpSuccess, setFpSuccess] = useState("");
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    if (resendTimer <= 0) return;
    const timer = setTimeout(() => setResendTimer((t) => t - 1), 1000);
    return () => clearTimeout(timer);
  }, [resendTimer]);

  const getApiMessage = (data, fallback) =>
    data?.message?.message ||
    (typeof data?.message === "string" ? data.message : "") ||
    fallback;

  const openForgotPassword = () => {
    setFpUsername(username?.trim() || "");
    setOtp("");
    setNewPassword("");
    setConfirmPassword("");
    setFpError("");
    setFpSuccess("");
    setView("forgot");
  };

  const backToLogin = () => {
    setFpError("");
    setView("login");
  };

  const sendOtp = async () => {
    setFpError("");
    setFpSuccess("");
    if (!fpUsername?.trim()) {
      setFpError("Please enter username.");
      return;
    }
    setFpLoading(true);
    try {
      const response = await fetch("https://api.mirai.healthcare/api/user/forgot/password", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: fpUsername.trim(), account_type: "STUDENT" }),
      });
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        setFpSuccess(getApiMessage(data, "OTP sent successfully to your registered contact."));
        setResendTimer(30);
        setView("reset");
      } else {
        setFpError(getApiMessage(data, "Unable to send OTP. Please try again."));
      }
    } catch (err) {
      setFpError("An error occurred. Please try again.");
    } finally {
      setFpLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setFpError("");
    setFpSuccess("");
    if (!otp?.trim()) {
      setFpError("Please enter OTP.");
      return;
    }
    if (!newPassword?.trim()) {
      setFpError("Please enter new password.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setFpError("Passwords do not match.");
      return;
    }
    setFpLoading(true);
    try {
      const response = await fetch("https://api.mirai.healthcare/api/user/reset-password", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: fpUsername.trim(),
          otp: otp.trim(),
          password: newPassword.trim(),
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        setUsername(fpUsername.trim());
        setPassword("");
        setView("login");
        setFpSuccess("Password reset successfully. Please sign in with your new password.");
      } else {
        setFpError(getApiMessage(data, "Unable to reset password. Please try again."));
      }
    } catch (err) {
      setFpError("An error occurred. Please try again.");
    } finally {
      setFpLoading(false);
    }
  };

  const handleSubmit = (event) => {
    if (view === "login") {
      handleLogin(event);
      return;
    }
    event.preventDefault();
    if (view === "forgot") sendOtp();
    else handleResetPassword();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      return;
    }

    if (isExpired(token)) {
      localStorage.removeItem("token");
      return;
    }

    navigation(routes.index, { replace: true });
  }, [navigation, routes.index]);

  const schoolName = Automationdata?.schoolName;
  const schoolLogo = Automationdata?.schoolLogo;

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    // if (!school_id) {
    //   setLoading(false);
    //   setError3('Please enter Student ID.');
    //   return;
    // }
    if (!username) {
      setLoading(false);
      setError1('Please enter username.');
      return;
    }
    if (!password) {
      setLoading(false);
      setError2('Please enter password.');
      return;
    }

    try {
      const response = await fetch('https://api.mirai.healthcare/api/user/signin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: username?.trim(), password: password?.trim() }),
      });
      const data = await response.json();
      if (response.ok) {
        clearAllCache();
        localStorage.setItem('token', data?.message?.token);
        localStorage.setItem('siblings', JSON.stringify(data.message.siblings));
        // navigation(routes.index, { replace: true });
        window.location.href="/index";


        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: "LOGIN_SUCCESS",
              token: data?.message?.token
            })
          );
        }
      } else {
        setError(data?.message?.message || 'Login failed');
        alert(data?.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    newPassword: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      const token = localStorage.getItem("token");

      if (token && !isExpired(token)) {
        navigation(routes.index, { replace: true });
        return;
      }

      navigation(routes.login, { replace: true });
    };

    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigation, routes.index, routes.login]);

  const fetchAdmissionPermission = async () => {
    try {
      const response = await axios.get(
        "https://api.mirai.healthcare/api/user/service-permission/filter?module_code=LOGIN-ADMISSION-NUMBER&allow_service=true",
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            "x-auth": authToken,
          },
        }
      );

      // ✅ agar data hai to show karo
      if (response?.data && response?.data?.message?.services?.length > 0) {
        setShowAdmissionLoginData(response?.data?.message?.services);
        setShowAdmissionLogin(true);
      } else {
        setShowAdmissionLogin(false);
      }
    } catch (error) {
      console.log(error);
      setShowAdmissionLogin(false);
    }
  };

  useEffect(() => {
    fetchAdmissionPermission();
  }, []);

  const fetchSchoolAutomationData = async () => {
    try {
      const response = await axios.get(
        "https://api.mirai.healthcare/api/head/school-rule/school-automation",
        {
          headers: {
            accept: "application/json",
          },
        }
      );
      if (response?.data) {
        setAutomationdata(response?.data?.[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    clearAllCache();
    fetchSchoolAutomationData();
  }, []);


  return (
    <>
      <div className="container-fuild">
        <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row">
            <div className="col-lg-6">
              <div className="d-lg-flex align-items-center justify-content-center bg-light-300 d-lg-block d-none flex-wrap vh-100 overflowy-auto bg-01">
                <div>
                  <ImageWithBasePath
                    src="assets/img/authentication/authentication-06.svg"
                    alt="Img"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                <div className="col-md-8 mx-auto p-4">
                  <form onSubmit={handleSubmit}>
                    <div>
                      <div className=" mx-auto mb-5 text-center">
                        <img src={schoolLogo} className="img-fluid logo_css"
                          alt="Logo" />
                        {/* // <ImageWithBasePath
                        //   src="assets/img/logo.webp"
                        //   className="img-fluid logo_css"
                        //   alt="Logo"
                        // /> */}
                      </div>
                      <div className="card">
                        {view !== "login" ? (
                        <div className="card-body p-4">
                          <div className="mb-4 text-center">
                            <span
                              className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-transparent mb-3"
                              style={{ width: 56, height: 56 }}
                            >
                              <i className={`ti ${view === "forgot" ? "ti-lock-question" : "ti-shield-lock"} fs-24 text-primary`} />
                            </span>
                            <h2 className="mb-2">
                              {view === "forgot" ? "Forgot Password?" : "Reset Password"}
                            </h2>
                            <p className="mb-0">
                              {view === "forgot"
                                ? "Enter your username and we'll send you an OTP to reset your password"
                                : <>Enter the OTP sent for <strong>{fpUsername}</strong> and set a new password</>}
                            </p>
                          </div>

                          {fpError && (
                            <Alert variant="danger" className="py-2">{fpError}</Alert>
                          )}
                          {fpSuccess && (
                            <Alert variant="success" className="py-2">{fpSuccess}</Alert>
                          )}

                          {view === "forgot" ? (
                            <div className="mb-3">
                              <label className="form-label">User Name</label>
                              <div className="input-icon position-relative">
                                <span className="input-icon-addon">
                                  <i className="ti ti-user" />
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={fpUsername}
                                  onChange={(e) => setFpUsername(e.target.value)}
                                  autoFocus
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="mb-3">
                                <label className="form-label">OTP</label>
                                <div className="input-icon position-relative">
                                  <span className="input-icon-addon">
                                    <i className="ti ti-key" />
                                  </span>
                                  <input
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={6}
                                    className="form-control"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                                    autoFocus
                                  />
                                </div>
                                <div className="d-flex justify-content-end mt-1">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0 fs-13"
                                    onClick={sendOtp}
                                    disabled={fpLoading || resendTimer > 0}
                                  >
                                    {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : "Resend OTP"}
                                  </button>
                                </div>
                              </div>
                              <div className="mb-3">
                                <label className="form-label">New Password</label>
                                <div className="pass-group">
                                  <input
                                    type={passwordVisibility.newPassword ? "text" : "password"}
                                    className="pass-input form-control"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                  />
                                  <span
                                    className={`ti toggle-passwords ${passwordVisibility.newPassword ? "ti-eye" : "ti-eye-off"}`}
                                    onClick={() => togglePasswordVisibility("newPassword")}
                                  ></span>
                                </div>
                              </div>
                              <div className="mb-3">
                                <label className="form-label">Confirm Password</label>
                                <div className="pass-group">
                                  <input
                                    type={passwordVisibility.confirmPassword ? "text" : "password"}
                                    className="pass-input form-control"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                  />
                                  <span
                                    className={`ti toggle-passwords ${passwordVisibility.confirmPassword ? "ti-eye" : "ti-eye-off"}`}
                                    onClick={() => togglePasswordVisibility("confirmPassword")}
                                  ></span>
                                </div>
                              </div>
                            </>
                          )}

                          <div className="mb-3">
                            <button
                              type="submit"
                              className="btn btn-primary w-100"
                              disabled={fpLoading}
                            >
                              {fpLoading
                                ? "Please wait..."
                                : view === "forgot" ? "Send OTP" : "Reset Password"}
                            </button>
                          </div>
                          <div className="text-center">
                            {view === "reset" && (
                              <button
                                type="button"
                                className="btn btn-link p-0 me-3"
                                onClick={() => { setFpError(""); setFpSuccess(""); setView("forgot"); }}
                              >
                                <i className="ti ti-edit me-1" />Change Username
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={backToLogin}
                            >
                              <i className="ti ti-arrow-left me-1" />Back to Sign In
                            </button>
                          </div>
                        </div>
                        ) : (
                        <div className="card-body p-4">
                          <div className=" mb-4 text-center">
                            <h2 className="mb-2">Welcome</h2>
                            <p className="mb-0">
                              Please enter your details to sign in
                            </p>
                          </div>
                          {fpSuccess && (
                            <Alert variant="success" className="py-2" dismissible onClose={() => setFpSuccess("")}>
                              {fpSuccess}
                            </Alert>
                          )}
                          {/* <div className="mt-4">
                            <div className="d-flex align-items-center justify-content-center flex-wrap">
                              <div className="text-center me-2 flex-fill">
                                <Link
                                  to="#"
                                  className="bg-primary br-10 p-2 btn btn-primary  d-flex align-items-center justify-content-center"
                                >
                                  <ImageWithBasePath
                                    className="img-fluid m-1"
                                    src="assets/img/icons/facebook-logo.webp"
                                    alt="Facebook"
                                  />
                                </Link>
                              </div>
                              <div className="text-center me-2 flex-fill">
                                <Link
                                  to="#"
                                  className=" br-10 p-2 btn btn-outline-light  d-flex align-items-center justify-content-center"
                                >
                                  <ImageWithBasePath
                                    className="img-fluid  m-1"
                                    src="assets/img/icons/google-logo.webp"
                                    alt="Facebook"
                                  />
                                </Link>
                              </div>
                              <div className="text-center flex-fill">
                                <Link
                                  to="#"
                                  className="bg-dark br-10 p-2 btn btn-dark d-flex align-items-center justify-content-center"
                                >
                                  <ImageWithBasePath
                                    className="img-fluid  m-1"
                                    src="assets/img/icons/apple-logo.webp"
                                    alt="Apple"
                                  />
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="login-or">
                            <span className="span-or">Or</span>
                          </div> */}
                          <div className="mb-3">

                            {/* <label className="form-label">School ID</label>
                            <div className="input-icon mb-3 position-relative">
                              <span className="input-icon-addon">
                                <i className="ti ti-id" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={school_id}
                                onChange={(e) => setSchoolId(e.target.value)}
                              />
                              {error3 && <p className="dangerColor">{error3}</p>}
                            </div> */}


                            <label className="form-label">User Name</label>
                            <div className="input-icon mb-3 position-relative">
                              <span className="input-icon-addon">
                                <i className="ti ti-mail" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                              />
                              {error1 && <p className="dangerColor">{error1}</p>}
                            </div>

                            {/* Password Field */}
                            <label className="form-label">Password</label>
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.password
                                    ? "text"
                                    : "password"
                                }
                                className="pass-input form-control"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              {error2 && <p className="dangerColor">{error2}</p>}
                              <span
                                className={`ti toggle-passwords ${passwordVisibility.password
                                  ? "ti-eye"
                                  : "ti-eye-off"
                                  }`}
                                onClick={() =>
                                  togglePasswordVisibility("password")
                                }
                              ></span>
                            </div>
                          </div>
                          <div className="form-wrap form-wrap-checkbox mb-3">
                            <div className="d-flex align-items-center">
                              <div className="form-check form-check-md mb-0">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                />
                              </div>
                              <p className="ms-1 mb-0 ">Remember Me</p>
                            </div>
                            <div className="text-end">
                              <button
                                type="button"
                                className="btn btn-link link-danger p-0"
                                onClick={openForgotPassword}
                              >
                                Forgot Password?
                              </button>
                            </div>
                          </div>

                          <div className="mb-3">
                            <button
                              // onClick={navigationPath}
                              type="submit"
                              className="btn btn-primary w-100"
                              disabled={loading}
                            >
                              Sign In
                            </button>
                          </div>
                          <div className="text-center">
                            <h6 className="fw-normal text-dark mb-0">
                              Don’t have an account?{" "}
                              <Link to={routes.createenquiry} className="hover-a ">
                                {" "}
                                Create Enquiry
                              </Link>
                            </h6>
                          </div>
                          {showAdmissionLogin && (
                            <div className="text-center mt-2">
                              <div className="d-flex align-items-center mb-3">
                                <hr className="flex-grow-1" />
                                <span className="mx-2 text-muted">OR</span>
                                <hr className="flex-grow-1" />
                              </div>

                              <Link
                                to={routes.admissionlogin}
                                className="btn w-100"
                                style={{
                                  background: "rgb(49.0717821782, 84.3737623762, 223.2282178218)",
                                  color: "#fff",
                                  borderRadius: "12px",
                                  padding: "10px",
                                  fontWeight: "600",
                                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
                                }}
                              >
                                {showAdmissionLoginData?.[0]?.module_name}
                              </Link>
                            </div>
                          )}
                        </div>
                        )}
                      </div>
                      <div className="mt-5 text-center">
                        <p className="mb-0 ">Copyright © 2025 - Erish</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
